import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ShoppingCart, Phone, ChevronDown } from 'lucide-react';
import { navigationLinks } from '../data/mock';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState(null);

  return (
    <header className="bg-gradient-to-r from-[#7CB342] to-[#00BCD4] shadow-lg sticky top-0 z-50">
      {/* Main header */}
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-4">
          {/* Logo Ecopra */}
          <Link to="/" className="flex items-center gap-3 group cursor-pointer">
            <img 
              src="https://customer-assets.emergentagent.com/job_news-3/artifacts/eyvztt7z_Capture%20d%E2%80%99e%CC%81cran%202026-03-23%20a%CC%80%2013.05.43.png"
              alt="Logo Ecopra"
              className="h-20 w-auto group-hover:scale-105 transition-transform cursor-pointer"
            />
            <div className="text-xs text-white/90 font-medium flex items-center gap-1 cursor-pointer">
              <span className="text-xl">🇨🇭</span>
              <span>Suisse</span>
              <span className="text-white/60">•</span>
              <span className="text-xl">🇫🇷</span>
              <span>Made in France</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navigationLinks.map((link) => (
              <div
                key={link.name}
                className="relative group"
                onMouseEnter={() => link.submenu && setActiveSubmenu(link.name)}
                onMouseLeave={() => setActiveSubmenu(null)}
              >
                <Link
                  to={link.path}
                  className="text-white hover:text-[#E8F5E9] font-semibold transition-colors flex items-center gap-1"
                >
                  {link.name}
                  {link.submenu && <ChevronDown size={16} />}
                </Link>
                {link.submenu && activeSubmenu === link.name && (
                  <div className="absolute top-full left-0 mt-2 bg-white shadow-xl rounded-lg py-2 min-w-[250px] z-50 border border-gray-100">
                    {link.submenu.map((item) => (
                      <Link
                        key={item.name}
                        to={item.path}
                        className="block px-4 py-2 text-gray-700 hover:bg-gradient-to-r hover:from-[#7CB342]/10 hover:to-[#00BCD4]/10 hover:text-[#00BCD4] transition-colors"
                      >
                        {item.name}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </nav>

          {/* Mobile menu button */}
          <button
            className="lg:hidden text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav className="lg:hidden pb-4 border-t border-white/20 pt-4">
            {navigationLinks.map((link) => (
              <div key={link.name}>
                <Link
                  to={link.path}
                  className="block py-2 text-white hover:text-[#E8F5E9] font-medium"
                  onClick={() => !link.submenu && setMobileMenuOpen(false)}
                >
                  {link.name}
                </Link>
                {link.submenu && (
                  <div className="pl-4 space-y-1">
                    {link.submenu.map((item) => (
                      <Link
                        key={item.name}
                        to={item.path}
                        className="block py-1 text-sm text-white/80 hover:text-white"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        {item.name}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;